import { render, staticRenderFns } from "./resultsPage.vue?vue&type=template&id=54a8cbea&scoped=true&"
import script from "./resultsPage.vue?vue&type=script&lang=js&"
export * from "./resultsPage.vue?vue&type=script&lang=js&"
import style0 from "./resultsPage.vue?vue&type=style&index=0&id=54a8cbea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8cbea",
  null
  
)

export default component.exports